"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.downloadTxt = exports.downloadFile = exports.generateUrl = exports.putWithBody = exports.put = exports.postWithParams = exports.post = exports.del = exports.get = exports.ApiError = void 0;
const vue_1 = __importDefault(require("vue"));
class ApiError extends Error {
    constructor(type, msg) {
        super();
        this.message = msg;
        this._type = type;
    }
    get type() {
        return this._type;
    }
}
exports.ApiError = ApiError;
function get(command, action, params) {
    return executionWithParams('get', command, action, params);
}
exports.get = get;
function del(command, action, params) {
    return executionWithParams('delete', command, action, params);
}
exports.del = del;
function post(command, action, body) {
    return executionWithBody('post', command, action, body);
}
exports.post = post;
function postWithParams(command, action, params) {
    return executionWithParams('post', command, action, params);
}
exports.postWithParams = postWithParams;
function put(command, action, body, params) {
    return executionWithParams('put', command, action, body);
}
exports.put = put;
function putWithBody(command, action, body) {
    return executionWithBody('put', command, action, body);
}
exports.putWithBody = putWithBody;
function generateUrl(command, action, params) {
    let baseUrl = `?cr=${command}&ac=${action}`;
    if (params) {
        for (const key in params) {
            if (params[key] == null)
                continue;
            if (params[key] instanceof Array) {
                // (params[key] as Array<any>).forEach(param => {
                //     baseUrl += `&${key}=${param}`;
                // });
                baseUrl += `&${key}=${params[key].join(',')}`;
            }
            else {
                baseUrl += `&${key}=${params[key]}`;
            }
        }
    }
    return baseUrl;
}
exports.generateUrl = generateUrl;
function executionWithParams(method, command, action, params) {
    let baseUrl = generateUrl(command, action, params);
    return vue_1.default.$http[method](baseUrl)
        .then(response => response.data)
        .then((data) => {
        // if (command=='Modalidade'){
        //     console.log('core.ts', command, action, params); //, params
        //     console.log('core.ts',data);
        // }
        if (!data.success) {
            throw new ApiError(data.tipoErro, data.msg);
        }
        return data;
    });
}
function downloadFile(command, action, params) {
    let baseUrl = generateUrl(command, action, params);
    return vue_1.default.$http['get'](baseUrl, {
        responseType: 'blob'
    })
        .then((response) => {
        const blob = new Blob([response.data], { type: response.headers['content-type'] });
        const url = URL.createObjectURL(blob);
        window.open(url, 'blank');
        URL.revokeObjectURL(url);
    });
}
exports.downloadFile = downloadFile;
function downloadTxt(command, action, params) {
    var nome = "";
    if (params) {
        nome = String(params.nome);
    }
    let baseUrl = generateUrl(command, action, params);
    return vue_1.default.$http['get'](baseUrl, {
        responseType: 'blob'
    })
        .then((response) => {
        const blob = new Blob([response.data]);
        const url = URL.createObjectURL(blob);
        // Crie um elemento de link para iniciar o download
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', nome); // Substitua pelo nome desejado para o arquivo e sua extensão
        // Acione o clique no link para iniciar o download
        link.click();
        URL.revokeObjectURL(url);
    });
}
exports.downloadTxt = downloadTxt;
function executionWithBody(method, command, action, body, params) {
    let baseUrl = `?cr=${command}&ac=${action}`;
    if (params) {
        for (const key in params) {
            if (params[key] == null)
                continue;
            if (params[key] instanceof Array) {
                baseUrl += `&${key}=${params[key].join(',')}`;
            }
            else {
                baseUrl += `&${key}=${params[key]}`;
            }
        }
    }
    const data = new FormData();
    for (const key in body) {
        data.append(key, body[key]);
    }
    return vue_1.default.$http[method](baseUrl, data, {
        headers: {
            'Content-Type': 'multipart/form-data'
        }
    })
        .then(response => response.data)
        .then((data) => {
        // // if (command=='Modalidade'){
        //     console.log('core.ts', command, action, params); //, params
        //     console.log('core.ts',data);
        // // }
        if (!data.success)
            throw new ApiError(data.tipoErro, data.msg);
        return data;
    });
}
